/**
 * Imagery "capability" groupings
 * These groupings are used to identify the "capability"
 * of satellites and their constellations (item types, strips, items, etc),
 * ie) what kind of imagery and categorization of bands does a satellite produce
 * Formerly distinguished as "Band Combos"
 */
export const IMAGERY_CAPABILITIES = {
  visual: 'visual', // RGB Bands
  nir: 'nir', // NIR Bands
  multispectral: 'multispectral', // Anything with more than Visual and NIR
  radio: 'radio', // Radio Waves (Sentinel 2)
  pan: 'pan', // Pansharpened (SkySat)
};

/**
 * PSScene imagery "capabilities" asset mappings
 * Assets that are at MINIMUM present for each imagery capability
 * Used in mapping legacy PSSceneXBand item types to PSScene
 * and determining asset imagery capability labels.
 */
export const PSSCENE_IMAGERY_CAPABILITIES_ASSETS = {
  [IMAGERY_CAPABILITIES.multispectral]: 'basic_analytic_8b', // (8-band sensors only, no 4/3-band)
  [IMAGERY_CAPABILITIES.nir]: 'basic_analytic_4b', // (~ legacy 4-band sensors and UP, no 3-band)
  [IMAGERY_CAPABILITIES.visual]: 'ortho_visual', // (~ legacy 3-band sensors AND UP, so all PSSCENE) NOTE: NOT used to determine label
};

// "Asset Capabilities"
// NOTE: In the future, we could have more "asset based capabilities",
// (ex. derived assets that are generated and may not exist yet, like surface reflectance),
// and create a mapping between those asset capabilities and their asset filenames (or maybe even item types).
// These would be different than "imagery capabilities" which are essentially radiometric descriptions (band combos).
// Since for now, we only expose controls for surface reflectance, we just have an explicit sr redux state in item-types slice.

/**
 * List of Surface Reflectance assets available for various item types.
 * NOTE: In Planet Data API, when using an AssetFilter, it's config array does an implicit OR.
 */
export const SR_ASSETS = [
  'analytic_sr', // REOrthoTile
  'ortho_analytic_sr', // SkySat, SkySatCollect
  'ortho_analytic_4b_sr', // PSScene (4 band and up)
  'ortho_analytic_8b_sr', // PSScene (8 band)
  'basic_sr_hdf5', // TanagerScene
  'ortho_sr_hdf5', // TanagerScene
];
